import React from "react";
import { useNavigate } from "react-router-dom";

function SurgicalDashboard() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userRole");
    navigate("/login");
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Surgical Dashboard</h2>

      <div style={styles.buttonContainer}>

        <button style={styles.button} onClick={() => navigate("/orders")}>
          My Orders
        </button>

        <button style={styles.button} onClick={() => navigate("/profile")}>
          Profile
        </button>

        <button style={styles.button} onClick={() => navigate("/shop-surgical")}>
          Shop Surgical Items
        </button>

        <button style={styles.logoutButton} onClick={handleLogout}>
          Logout
        </button>

      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: "40px",
    textAlign: "center",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "30px",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    maxWidth: "300px",
    margin: "0 auto",
  },
  button: {
    padding: "12px",
    backgroundColor: "#007BFF",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "16px",
  },
  logoutButton: {
    padding: "12px",
    backgroundColor: "red",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "16px",
  },
};

export default SurgicalDashboard;
